import { useState } from 'react';
import { Dialog, DialogContent, DialogHeader, DialogTitle } from '@/components/ui/dialog';
import { Button } from '@/components/ui/button';
import { Textarea } from '@/components/ui/textarea';
import { addIssueFeedback } from '@/lib/storage';
import { Issue } from '@/types';

interface Props {
  issue: Issue;
  open: boolean;
  onClose: () => void;
}

export default function IssueFeedbackModal({ issue, open, onClose }: Props) {
  const [rating, setRating] = useState<number>(5);
  const [feedback, setFeedback] = useState('');
  if (issue.status !== 'resolved') return null;
  
  const submit = () => {
    addIssueFeedback(issue.id, rating, feedback);
    onClose();
  };

  return (
  <Dialog open={open} onOpenChange={onClose}>
    <DialogContent className="sm:max-w-md rounded-2xl">
      <DialogHeader className="space-y-2">
        <DialogTitle className="text-xl font-semibold text-center">
          How was the resolution?
        </DialogTitle>
        <p className="text-sm text-muted-foreground text-center">
          Your feedback helps improve civic services
        </p>
      </DialogHeader>

      <div className="space-y-6 pt-2">
        {/* ⭐ Rating */}
        <div className="flex justify-center gap-3">
          {[1, 2, 3, 4, 5].map((n) => (
            <button
              key={n}
              onClick={() => setRating(n)}
              className={`text-3xl transition-transform hover:scale-110 focus:outline-none ${
                n <= rating ? 'text-yellow-400' : 'text-gray-300'
              }`}
              aria-label={`Rate ${n} star`}
            >
              ★
            </button>
          ))}
        </div>

        {/* Rating label */}
        <div className="text-center text-sm text-muted-foreground">
          {rating === 5 && 'Excellent'}
          {rating === 4 && 'Good'}
          {rating === 3 && 'Average'}
          {rating === 2 && 'Poor'}
          {rating === 1 && 'Very poor'}
        </div>

        {/* Feedback */}
        <Textarea
          placeholder="Share any additional feedback (optional)"
          value={feedback}
          onChange={(e) => setFeedback(e.target.value)}
          className="min-h-[90px]"
        />

        {/* Actions */}
        <div className="flex gap-3 pt-2">
          <Button
            variant="outline"
            className="w-1/2"
            onClick={onClose}
          >
            Cancel
          </Button>

          <Button
            className="w-1/2"
            onClick={submit}
          >
            Submit Feedback
          </Button>
        </div>
      </div>
    </DialogContent>
  </Dialog>
);

}
